import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModelServiceService {
  private modalState: { [key: string]: boolean } = {};
  constructor() { }
   open(modalId: string): void {
    this.modalState[modalId] = true;
  }

  close(modalId: string): void {
    this.modalState[modalId] = false;
  }

  isOpen(modalId: string): boolean {
    alert(modalId)
    alert(this.modalState[modalId])
    return this.modalState[modalId];
  }
}
